import { render, staticRenderFns } from "./ResponseVoiceMailsForm.vue?vue&type=template&id=829f1534&"
import script from "./ResponseVoiceMailsForm.vue?vue&type=script&lang=js&"
export * from "./ResponseVoiceMailsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports